import React from 'react'
import {useHistory} from 'react-router-dom'
import {recordDisplay} from 'utils'
import moment from 'moment'
import {useSelector} from 'hooks/redux'
import {ListData} from 'procedureStatuses/list/components'
import {procedureTypes} from 'procedureStatuses/List'
import styles from 'procedureStatuses/ListNotAdmin.scss'

export const statusDisplay = (status, application_status) => {
  if (status === 'done') {
    return '完了'
  } else if (application_status === 'applying') {
    return '確認中'
  } else if (application_status === 'none' || application_status === 'rejected' || application_status === 'working') {
    return '未対応'
  } else {
    return '対応中'
  }
}

const Row = ({procedureStatus}) => {
  const history = useHistory()

  const handleClick = () => {
    if (procedureStatus.link) {
      history.push(procedureStatus.link)
    }
  }

  return (
    <tr onClick={handleClick} className={procedureStatus.link ? styles.clickableRow : ''}>
      <td>
        {procedureStatus.request_status ? '依頼日：' : '申請日：'}{' '}
        {recordDisplay(procedureStatus.created_at && moment(procedureStatus.created_at).format('YYYY/MM/DD'))}
      </td>
      <td>{recordDisplay(procedureTypes[procedureStatus.procedure_type])}</td>
      <td>{statusDisplay(procedureStatus.status, procedureStatus.application_status)}</td>
    </tr>
  )
}

const ListNotAdmin = () => {
  const procedureStatuses = useSelector((state) => state.procedureStatuses.list.data)

  return (
    <div>
      <ListData />
      <div className="l-title-wrap">
        <div className="l-wrap-xxl">
          <h1 className="m-title-main">進行中の手続き一覧</h1>
        </div>
      </div>
      <div className="l-wrap-xs">
        <div className="l-overflow-scroll">
          <table className={styles.list + ' m-table-list'}>
            <thead>
              <tr>
                <th>日時</th>
                <th>手続き</th>
                <th>ステータス</th>
              </tr>
            </thead>
            <tbody>
              {procedureStatuses.map((procedureStatus) => (
                <Row procedureStatus={procedureStatus} key={procedureStatus.id} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ListNotAdmin
